import { put } from 'typed-redux-saga'
import { AppSocketType, WorkerEvent } from 'Modules'
import { ChatSocketNS, chatSocketSlice } from 'Pages/chat'

export function* closeChatConnection(action: ChatSocketNS.CloseConnection) {
	if (!('serviceWorker' in navigator)) return

	const { isNeedClearChannels = false } = action?.payload

	yield* put(chatSocketSlice.actions.setHasWorker(false))
	if (isNeedClearChannels) yield* put(chatSocketSlice.actions.setChannels(new Set()))

	navigator.serviceWorker.controller?.postMessage({
		appSocketType: AppSocketType.UNI_CHAT,
		data: {
			type: WorkerEvent.CLOSE_CONNECTION,
		},
	})
}
